import { Alert as AntdAlert } from "antd";

const AlertPolyfill: typeof AntdAlert = AntdAlert;

export default AlertPolyfill;